export default __webpack_public_path__ + "static/media/kitchen5-beforeB-768w.c675518b.webp";